// npx create-react-app discord-clone --template redux
// This project uses redux and not react context api..
// App deployed Link --> https://discord-clone-7cd1f.web.app

import React, { useEffect } from 'react'
import Chat from './components/Chat/Chat'
import Sidebar from './components/Sidebar/Sidebar'
import './App.css'
import { login, logout, selectUser } from './features/userSlice'
import { useDispatch, useSelector } from 'react-redux'
import Login from './components/Login/Login'
import { auth } from './firebase'

function App() {

    const dispatch = useDispatch();
    const user = useSelector(selectUser);

    useEffect(() => {
        auth.onAuthStateChanged(authUser => {
            console.log(authUser)
            if(authUser) {
                // the user is logged in
                dispatch(
                    login({
                        uid: authUser.uid,
                        photo: authUser.photoURL,
                        email: authUser.email,
                        displayName: authUser.displayName
                    })
                );
            } else {
                // the user logged out
                dispatch(logout());
            }
        })
    }, [dispatch])

    return (
        <div className="app">
            {
                user ?
                    (<>
                        <Sidebar />
                        <Chat />
                    </>) : (
                        <Login />
                    )
            }
        </div>
    )
}

export default App
